import { Grid } from "@mui/material";
import { HeaderData } from "./components/HeaderData";
import { AdditionsTable } from "./components/tables/additions-table/AdditionsTable";
import { HeatingsTable } from "./components/tables/heatings-table/HeatingsTable";
import { ProbesTable } from "./components/tables/probes-table/ProbesTable";
import { TableChemistry } from "@/pages/laboratory/data-entry/components/tables/chemistries/TableChemistry";
import { useHeatReportContext } from "@/pages/heat-report/context/HeatReportContext";

export const LMFProcessData = () => {
  const {
    state: { lmfProcessData, heat },
  } = useHeatReportContext();

  return (
    <>
      <Grid item xs={12} container spacing={2} justifyContent="center">
        <Grid item xs={12}>
          <HeaderData />
        </Grid>
      </Grid>

      <Grid item xs={12} container spacing={2} justifyContent="center">
        <Grid item xs={12} sm={4} md={4}>
          <ProbesTable />
        </Grid>
        <Grid item xs={12} sm={4} md={4}>
          <AdditionsTable />
        </Grid>
        <Grid item xs={12} sm={4} md={4}>
          <HeatingsTable />
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          {heat?.HeatId && lmfProcessData?.AssetId ? (
            <TableChemistry
              key={`lmf-data-entry_${heat.HeatId}_${lmfProcessData.ProcessId}`}
              assetId={lmfProcessData.AssetId}
              heatId={heat.HeatId}
            />
          ) : null}
        </Grid>
      </Grid>
    </>
  );
};
